import { generateMaterialThemePalettes } from "./material-palette-generator";

function generateMaterialThemeCSS(palettes: any): string {
  const p = palettes.primary;
  const a = palettes.accent;

  return `
.mat-mdc-raised-button.mat-primary,.mat-mdc-unelevated-button.mat-primary{background-color:${p[500]}!important;color:${p.contrast[500]}!important}
.mat-mdc-raised-button.mat-primary:hover,.mat-mdc-unelevated-button.mat-primary:hover{background-color:${p[700]}!important}
.mat-mdc-button.mat-primary{color:${p[500]}!important}
.mat-mdc-outlined-button.mat-primary,.mat-stroked-button.mat-primary,button[mat-stroked-button][color="primary"]{color:${p[500]}!important;border-color:${p[500]}!important}
.mat-mdc-outlined-button.mat-primary *,.mat-stroked-button.mat-primary *,button[mat-stroked-button][color="primary"] *{color:${p[500]}!important}
.mat-mdc-icon-button.mat-primary,button[mat-icon-button][color="primary"]{color:${p[500]}!important}
.mat-mdc-icon-button.mat-primary *,button[mat-icon-button][color="primary"] *{color:${p[500]}!important}
.mat-mdc-fab.mat-primary{background-color:${p[500]}!important;color:${p.contrast[500]}!important}
.mat-mdc-raised-button.mat-accent{background-color:${a[500]}!important;color:#ffffff!important}
.mat-mdc-button.mat-accent{color:${a[500]}!important}
.mat-stroked-button.mat-accent{color:#ffffff!important;border-color:${a[500]}!important}
.mat-stroked-button.mat-accent *{color:#ffffff!important}
.mat-button-toggle-group .mat-button-toggle-checked{background-color:${p[500]}!important;color:${p.contrast[500]}!important}
.mat-button-toggle-group .mat-button-toggle-checked *{color:${p.contrast[500]}!important}
.mat-button-toggle-group{border-color:${p[500]}!important}
.mat-button-toggle-group .mat-button-toggle:not(.mat-button-toggle-checked){color:${p[500]}!important}
.mat-button-toggle-group .mat-button-toggle:not(.mat-button-toggle-checked) *{color:${p[500]}!important}
.mat-mdc-checkbox.mat-primary .mdc-checkbox__native-control:checked ~ .mdc-checkbox__background{background-color:${p[500]}!important;border-color:${p[500]}!important}
.mat-mdc-checkbox.mat-primary{--mdc-checkbox-selected-icon-color:${p[500]};--mdc-checkbox-selected-hover-icon-color:${p[500]};--mdc-checkbox-selected-focus-icon-color:${p[500]};--mdc-checkbox-selected-pressed-icon-color:${p[700]};--mdc-checkbox-selected-checkmark-color:#ffffff}
.mat-mdc-checkbox.mat-primary .mat-ripple-element{background-color:${p[500]}33!important}
.mat-mdc-checkbox.mat-accent .mdc-checkbox__native-control:checked ~ .mdc-checkbox__background{background-color:${a[500]}!important;border-color:${a[500]}!important}
.mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-icon-color:${a[500]};--mdc-checkbox-selected-hover-icon-color:${a[500]};--mdc-checkbox-selected-focus-icon-color:${a[500]};--mdc-checkbox-selected-pressed-icon-color:${a[700]};--mdc-checkbox-selected-checkmark-color:#ffffff}
.mat-mdc-checkbox.mat-accent .mat-ripple-element{background-color:${a[500]}33!important}
.mat-mdc-checkbox .mdc-checkbox--disabled .mdc-checkbox__background{border-color:var(--gray-medium,#9e9e9e)!important;background-color:var(--gray-100,#eeeeee)!important}
.mat-mdc-checkbox.mat-mdc-checkbox-disabled{--mdc-checkbox-selected-icon-color:var(--gray-medium,#9e9e9e);--mdc-checkbox-selected-hover-icon-color:var(--gray-medium,#9e9e9e);--mdc-checkbox-selected-focus-icon-color:var(--gray-medium,#9e9e9e);--mdc-checkbox-selected-pressed-icon-color:var(--gray-medium,#9e9e9e);--mdc-checkbox-selected-checkmark-color:#ffffff}
.mat-mdc-radio-button.mat-primary.mdc-radio--selected .mdc-radio__outer-circle,.mat-mdc-radio-button.mat-primary.mdc-radio--selected .mdc-radio__inner-circle{border-color:${p[500]}!important}
.mat-mdc-radio-button.mat-primary .mdc-radio.mdc-radio--selected .mdc-radio__outer-circle{border-color:${p[500]}!important}
.mat-mdc-radio-button.mat-primary .mdc-radio.mdc-radio--selected .mdc-radio__inner-circle{border-color:${p[500]}!important;background-color:${p[500]}!important}
.mat-mdc-radio-button .mat-ripple-element{background-color:${p[500]}33!important}
.mat-mdc-radio-button.mat-primary .mat-ripple-element{background-color:${p[500]}33!important}
/* Radio via MDC CSS variables (primary) */
.mat-mdc-radio-button.mat-primary{
  --mdc-radio-selected-icon-color: ${p[500]};
  --mdc-radio-selected-hover-icon-color: ${p[500]};
  --mdc-radio-selected-focus-icon-color: ${p[500]};
  --mdc-radio-selected-pressed-icon-color: ${p[700]};
  --mat-mdc-radio-checked-ripple-color: ${p[500]};
}
/* Accent colored radios */
.mat-mdc-radio-button.mat-accent.mdc-radio--selected .mdc-radio__outer-circle{border-color:${a[500]}!important}
.mat-mdc-radio-button.mat-accent.mdc-radio--selected .mdc-radio__inner-circle{border-color:${a[500]}!important}
.mat-mdc-radio-button.mat-accent .mdc-radio.mdc-radio--selected .mdc-radio__outer-circle{border-color:${a[500]}!important}
.mat-mdc-radio-button.mat-accent .mdc-radio.mdc-radio--selected .mdc-radio__inner-circle{border-color:${a[500]}!important;background-color:${a[500]}!important}
.mat-mdc-radio-button.mat-accent .mat-ripple-element{background-color:${a[500]}33!important}
/* Radio via MDC CSS variables (accent) */
.mat-mdc-radio-button.mat-accent{
  --mdc-radio-selected-icon-color: ${a[500]};
  --mdc-radio-selected-hover-icon-color: ${a[500]};
  --mdc-radio-selected-focus-icon-color: ${a[500]};
  --mdc-radio-selected-pressed-icon-color: ${a[700]};
  --mat-mdc-radio-checked-ripple-color: ${a[500]};
}
/* Disabled radio color */
.mat-mdc-radio-button .mdc-radio:disabled .mdc-radio__outer-circle{border-color: var(--gray-medium, #9e9e9e) !important}
.mat-mdc-radio-button .mdc-radio:disabled .mdc-radio__inner-circle{border-color: var(--gray-medium, #9e9e9e) !important;background-color: var(--gray-medium, #9e9e9e) !important}
.mat-mdc-radio-button.mat-mdc-radio-disabled{
  --mdc-radio-selected-icon-color: var(--gray-medium, #9e9e9e);
  --mdc-radio-selected-hover-icon-color: var(--gray-medium, #9e9e9e);
  --mdc-radio-selected-focus-icon-color: var(--gray-medium, #9e9e9e);
  --mdc-radio-selected-pressed-icon-color: var(--gray-medium, #9e9e9e);
  --mat-mdc-radio-checked-ripple-color: var(--gray-medium, #9e9e9e);
}
.mat-mdc-slide-toggle.mat-primary .mdc-switch--selected .mdc-switch__handle::after{background-color:${p[700]}!important}
.mat-mdc-slide-toggle.mat-primary .mdc-switch--selected .mdc-switch__track::after,.mat-mdc-slide-toggle.mat-primary .mdc-switch--selected .mdc-switch__track::before{background-color:${p[300]}!important}
.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label{color:${p[500]}!important}
.mat-mdc-tab.mdc-tab--active .mdc-tab-indicator__content--underline{border-color:${p[500]}!important}
.mat-mdc-form-field.mat-focused .mat-mdc-notch-piece{border-color:${p[500]}!important}
.mat-mdc-form-field.mat-focused label{color:${p[500]}!important}
.mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected{color:${p[500]}!important}
.mat-mdc-progress-bar .mdc-linear-progress__bar-inner{border-color:${p[500]}!important}
.mat-mdc-progress-spinner circle{stroke:${p[500]}!important}
.mat-badge-primary .mat-badge-content{background-color:${p[500]}!important;color:${p.contrast[500]}!important}
.mat-badge-accent .mat-badge-content{background-color:${a[500]}!important;color:${a.contrast[500]}!important}
/* Stronger focus outline color for MDC notched-outline */
.mat-mdc-form-field.mdc-text-field--focused .mdc-notched-outline__leading,
.mat-mdc-form-field.mdc-text-field--focused .mdc-notched-outline__notch,
.mat-mdc-form-field.mdc-text-field--focused .mdc-notched-outline__trailing{border-color:${p[500]}!important}
.mat-mdc-form-field.mat-focused .mdc-notched-outline__leading,
.mat-mdc-form-field.mat-focused .mdc-notched-outline__notch,
.mat-mdc-form-field.mat-focused .mdc-notched-outline__trailing{border-color:${p[500]}!important}
.mat-mdc-form-field.mdc-text-field--focused .mdc-floating-label{color:${p[500]}!important}
.mat-mdc-form-field.mat-focused .mdc-floating-label{color:${p[500]}!important}
/* Inputs (filled) line ripple & caret in primary */
.mat-mdc-form-field.mat-focused .mdc-line-ripple,
.mat-mdc-form-field .mdc-line-ripple.mdc-line-ripple--active{background-color:${p[500]}!important;border-color:${p[500]}!important}
.mat-mdc-form-field.mat-focused .mdc-line-ripple::before,
.mat-mdc-form-field.mat-focused .mdc-line-ripple::after,
.mat-mdc-form-field .mdc-line-ripple.mdc-line-ripple--active::before,
.mat-mdc-form-field .mdc-line-ripple.mdc-line-ripple--active::after{border-bottom-color:${p[500]}!important}
.mat-mdc-form-field .mat-mdc-input-element{caret-color:${p[500]}!important}
/* Accent variants */
.mat-mdc-form-field.mat-accent.mdc-text-field--focused .mdc-notched-outline__leading,
.mat-mdc-form-field.mat-accent.mdc-text-field--focused .mdc-notched-outline__notch,
.mat-mdc-form-field.mat-accent.mdc-text-field--focused .mdc-notched-outline__trailing{border-color:${a[500]}!important}
.mat-mdc-form-field.mat-accent.mat-focused .mdc-floating-label{color:${a[500]}!important}
.mat-mdc-form-field.mat-accent.mat-focused .mdc-line-ripple,
.mat-mdc-form-field.mat-accent .mdc-line-ripple.mdc-line-ripple--active{background-color:${a[500]}!important;border-color:${a[500]}!important}
.mat-mdc-form-field.mat-accent.mat-focused .mdc-line-ripple::before,
.mat-mdc-form-field.mat-accent.mat-focused .mdc-line-ripple::after,
.mat-mdc-form-field.mat-accent .mdc-line-ripple.mdc-line-ripple--active::before,
.mat-mdc-form-field.mat-accent .mdc-line-ripple.mdc-line-ripple--active::after{border-bottom-color:${a[500]}!important}
.mat-mdc-form-field.mat-accent .mat-mdc-input-element{caret-color:${a[500]}!important}
/* Selected option text color inside panel */
.mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected .mdc-list-item__primary-text{color:${p[500]}!important}
/* Disabled buttons → use gray palette */
.mat-mdc-button-base:disabled,
.mat-mdc-button-base.mat-mdc-button-disabled,
.mat-mdc-button-base.mdc-button--disabled,
.mat-mdc-raised-button:disabled,
.mat-mdc-unelevated-button:disabled,
.mat-mdc-flat-button:disabled,
.mat-mdc-stroked-button:disabled,
.mat-mdc-outlined-button:disabled,
.mat-mdc-fab:disabled,
.mat-mdc-mini-fab:disabled{
  color: var(--gray-medium, #9e9e9e) !important;
  border-color: var(--gray-medium, #9e9e9e) !important;
  background-color: var(--gray-100, #eeeeee) !important;
}
  `;
}

export function applyMaterialThemeDynamically(): void {
  try {
    const ctx = localStorage.getItem("session_context");
    const el = document.getElementById("nexu-dynamic-material-theme");
    if (el) el.remove();
    if (!ctx) return;

    const s = JSON.parse(ctx);
    if (!s?.theme) return;

    const { neutral, primary, secondary } = s.theme;
    if (!neutral || !primary || !secondary) return;

    const p = generateMaterialThemePalettes({ neutral, primary, secondary });
    const css = generateMaterialThemeCSS(p);

    const style = document.createElement("style");
    style.id = "nexu-dynamic-material-theme";
    style.textContent = css;
    document.head.appendChild(style);

    console.log("✓ Material theme CSS injected");
  } catch (e) {
    console.error("Theme error:", e);
  }
}
